import React from 'react'
import Navbar from '../Navbar/Navbar.component'
import './login.css'

function Login() {
  return (
    <div>
        <Navbar logout={true}/>
        <div className='logoutMessageContainer'>
          <h4 id="logoutmessage">Logged out of the account 🛑</h4>
        </div>
    </div>
  )
}

export default Login